import React, { Component } from 'react';
import SerializeForm from 'form-serialize';
import * as api from '../api/api';
import { connect } from 'react-redux'
import WorkExperienceItemForm from './WorkExperienceItemForm';
import WorkExperienceList from './WorkExperienceList';

class WorkExperienceTab extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {
        list: [],
      }
    };
    this.handleFormOpen = this.handleFormOpen.bind(this);
    this.handleFormClose = this.handleFormClose.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this)
    this.handleDeleteItem = this.handleDeleteItem.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleOrganizationChange = this.handleOrganizationChange.bind(this)
  }

  handleFormOpen(event) {
    let data = Object.assign({}, this.state.data);
    let item = {
      'id': '',
      'organization': '',
      'role': '',
      'start_date': '',
      'end_date': '',
    }
    data.list.unshift(item)
    this.setState({data: data});
  }

  handleFormClose(event) {
    // Called on Cancel
    let data = Object.assign({}, this.state.data);
    let item = data.list[0];
    if(!item.id){
      data.list.shift(item)
    }
    this.setState({data: data});
  }




  onFormSubmit(e) {
    console.log("In onFormSubmit")
    e.preventDefault()
    const values = SerializeForm(e.target, { hash: true })
    console.log("values = " + JSON.stringify(values))

    var prm;
    if (values.id) {
      console.log("values.id = " + values.id)
      prm = api.updateWorkExperienceItem(this.props.user.accessToken, values)
    } else {
      prm = api.addWorkExperienceItem(this.props.user.accessToken, values)
    }
    prm.then((result) => {
        console.log("Done saveItem:" + JSON.stringify(result))
        console.log(JSON.stringify(this.state.data.list))
        let data = Object.assign({}, this.state.data);
        //data.id = result.id;
        if (values.id) {
        } else {
          console.log("result.id = " + result.id)
          data.list[0].id = result.id
        }
        data.list.sort(function(a,b){ return new Date(b.start_date) - new Date(a.start_date) ;}) ;
        this.setState({data: data});
      })
      .catch((err) => {
    // console.log(`error:${err.stack}`)
      console.log("err + " + err.stack)
      this.setState({ errorMsg: err.stack })
    })
  }

  handleChange(evt, id) {
    const data = Object.assign({}, this.state.data);
    if (id) {
      let element = data.list.find(workExp => workExp.id == id)
      if(element){
        element[evt.target.name] = evt.target.value;
      }
    } else {
      let element = data.list[0];
      element[evt.target.name] = evt.target.value;
    }

    this.setState({data: data});
  }

  handleOrganizationChange(val, id) {
    const data = Object.assign({}, this.state.data);
    console.log('Inside organization handle fn')
    if (id) {
      let element = data.list.find(workExp => workExp.id == id)
      if(element){
        element['organization'] = val;
      }
    } else {
      let element = data.list[0];
      element['organization'] = val;
    }

    this.setState({data: data});
  }

  handleDeleteItem(id) {
    console.log("In handleDeleteItem id=")
    api.deleteWorkExperienceItem(this.props.user.accessToken, id)
    .then((result) => {
      let data = Object.assign({}, this.state.data)
      data.list = data.list.filter(workExp => workExp.id != id)
      this.setState({data: data})
    })
    .catch((err) => {
    // console.log(`error:${err.stack}`)
      console.log("err + " + err.stack)
      this.setState({ errorMsg: err.stack })
    })
  }

  componentDidMount() {
    api.getWorkExperienceList(this.props.user.accessToken)
    .then((result) => {
      console.log("getWorkExperienceList: " + JSON.stringify(result))
      let data = Object.assign({}, this.state.data)
      data.list = result
      this.setState({data: data})
    })
  }

  render() {
    var curr = this;
      return (
      <div>
        <ToggleableWorkExperienceForm handleChange={this.handleChange} handleFormOpen={this.handleFormOpen}
        onFormSubmit = {this.onFormSubmit} handleFormClose = {this.handleFormClose} handleOrganizationChange={this.handleOrganizationChange}
        data={this.state.data.list[0]} checkForChange= {this.props.checkForChange}/>
         <h3> Work History  </h3>
         <WorkExperienceList list= {this.state.data.list} handleDeleteItem = {this.handleDeleteItem} onFormSubmit = {this.onFormSubmit} handleChange = {this.handleChange} handleOrganizationChange={this.handleOrganizationChange}/>
      </div>
      )
  }

}





class ToggleableWorkExperienceForm extends React.Component {
  state = {
    isOpen: false,
  };

  handleFormOpen = () => {
    this.setState({ isOpen: true });
    this.props.handleFormOpen();
    this.props.checkForChange('', true);
  };

  handleFormClose = () => {
    this.props.handleFormClose();
    this.setState({ isOpen: false });
    this.props.checkForChange('', false);
 };




  handleFormSubmit = (education) => {
    this.props.onFormSubmit(education);
    this.setState({ isOpen: false });
    this.props.checkForChange('', false);
  };

  handleChange =  (evt, id) => {
    this.props.handleChange(evt, id);
  }

  render() {
    if (this.state.isOpen) {

      return (
        <WorkExperienceItemForm
          onFormSubmit={this.handleFormSubmit}
          onFormClose={this.handleFormClose}
          onFormChange= {this.props.handleChange}
          onFormOrganizationChange= {this.props.handleOrganizationChange}
          workExpDetails = {this.props.data}
        />
      );
    } else {
      return (
          <button className="mdc-button" aria-label="Favorite" onClick={this.handleFormOpen}>
                Add Work Experience
          </button>
        );
    }
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkExperienceTab);



// WEBPACK FOOTER //
// ./src/views/WorkExperienceTab.jsx